module.exports = __webpack_public_path__ + "img/honer7.8b590e92.jpg";